/**
 * BlockTypesStep — create-wizard step 7 (W12 Part B, Task B5).
 *
 * The whitelist the strategist may plan with: the ten built-in block types and
 * the project's own subtypes, as the wizard's two selection tables. Everything
 * is allowed by default, and while it stays at the default the request omits
 * the field entirely (AC-047) — the dialog owns that rule, this step only
 * renders the value and reports changes.
 */
import React from 'react';
import type { BlockSubtype } from '@modules/firebase-core';
import {
  AvailableBlocksSection,
  type AvailableBlocksValue,
} from '../../AvailableBlocksSection';

export interface BlockTypesStepProps {
  subtypes: BlockSubtype[];
  value: AvailableBlocksValue;
  onChange: (value: AvailableBlocksValue) => void;
  disabled?: boolean;
}

export const BlockTypesStep: React.FC<BlockTypesStepProps> = ({
  subtypes,
  value,
  onChange,
  disabled = false,
}) => (
  <AvailableBlocksSection
    variant="table"
    subtypes={subtypes}
    value={value}
    onChange={onChange}
    disabled={disabled}
  />
);

BlockTypesStep.displayName = 'BlockTypesStep';
